// Copyright (c) Microsoft Corporation. All rights reserved.
import { stringify } from './stringify';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function castAsError(value) {
    // Early return if value is an Error
    if (value instanceof Error) {
        return value;
    }
    // Handle null values
    if (value == null) {
        return new Error('Unknown error');
    }
    // Check against the Error interface
    if (typeof value.name === 'string' && typeof value.message === 'string') {
        return value;
    }
    // Check if value is a string and assign it as the `message` parameter
    if (typeof value === 'string') {
        return new Error(value);
    }
    // Attempt to stringify the value
    try {
        return new Error(stringify(value));
    }
    catch (error) {
        return new Error(value.toString() || 'Unknown error');
    }
}
//# sourceMappingURL=castAsError.js.map